import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Inject, Input, NgZone, PLATFORM_ID, Renderer2 } from '@angular/core';
import { timer, Subject, Observable } from 'rxjs';
import { checkIsMobile } from '../util';
import { HorizontalSlideManagerService } from './horizontal-slide-manager.service';

/** 水平滑動，單個 slide 註冊指令 */
@Directive({
  selector: '[tmHorizontalSlide]'
})
export class HorizontalSlideDirective implements AfterViewInit {
  /** 是瀏覽器端渲染 */
  isBrowser: boolean;
  /** slide 元素 */
  get el() { return this.elRef ? this.elRef.nativeElement as HTMLElement : null; }
  /** 是否顯示，如果需要初始畫面就先顯示 slide 不等渲染結束就在第一塊下這個屬性為真 */
  @Input() isActive = false;
  /** 是第幾個 slide */
  index: number;

  constructor(
    private elRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private horizontalSlideManagerService: HorizontalSlideManagerService,
    private zone: NgZone,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngAfterViewInit(): void {
    if (this.isBrowser && !checkIsMobile() || !this.isBrowser) {
      this.el.classList.add('tm-hori-slide');
      if (this.isActive) {
        this.active();
      }
      this.horizontalSlideManagerService.registSlide(this, this.renderer);
    }
  }

  /** 管理器分派 index 給指令用的 */
  dispatchIndex(index: number) {
    this.index = index;
    this.el.dataset.index = '' + index;
  }

  /**
   * 顯示這個 slide
   * @returns 返回動畫結束狀態
   */
  active(): Observable<void> {
    this.isActive = true;
    this.el.classList.add('tm-hori-slide-active');
    this.el.style.zIndex = '';
    const subject = new Subject<void>();

    if (this.el.classList.contains('tm-hori-slide-before')) {
      timer(1000).subscribe(t => {
        this.zone.run(() => {
          this.el.classList.remove('tm-hori-slide-before');
          subject.next();
          subject.complete();
        });
      });
    }
    if (this.el.classList.contains('tm-hori-slide-after')) {
      timer(1000).subscribe(t => {
        this.zone.run(() => {
          this.el.classList.remove('tm-hori-slide-after');
          subject.next();
          subject.complete();
        });
      });
    }
    return subject.asObservable();
  }

  /** 不顯示這個 slide */
  unActive() {
    this.isActive = false;
    this.el.classList.remove('tm-hori-slide-active');
    timer(1000).subscribe(t => {
      this.el.style.zIndex = '0';
    });
  }

  /** 設為左側的 slide */
  setBefore() {
    this.el.classList.add('tm-hori-slide-before');
  }

  /** 設為右側的 slide */
  setAfter() {
    this.el.classList.add('tm-hori-slide-after');
  }
}
